import { IContentFulRaw } from '../model/contentful-model';

export const filterItems = (raw: IContentFulRaw | undefined, modelId: string) => {
  if (!raw) return [];
  return raw.items.filter(item => item.sys.contentType.sys.id === modelId);
}
